import React        from 'react'
import Routes       from 'react-static-routes'
import { hot }      from 'react-hot-loader'
import { Router, Route }  from 'react-static'
//
import Wrapper      from 'components/Wrapper'


// This is the default renderer for `<Routes>`
const RenderRoutes = ({ getComponentForPath }) => (
    // The default renderer uses a catch all route to receive the pathname
    <Route
        path="*"
        render={props => {
            // The pathname is used to retrieve the component for that path
            let Comp = getComponentForPath(props.location.pathname)
            // The component is rendered!
            return <Comp key={props.location.pathname} {...props} />
        }}
    />
)

const App = () => (
    <Router>
        <Wrapper>
            <Routes render={ RenderRoutes } />
        </Wrapper>
    </Router>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js